import type { FormValidationErrors } from "~/shared/hooks/use-form-validation.ts";

const TOP_LEVEL_FIELD_ORDER: { field: string; elementId: string }[] = [
	{ field: "customer", elementId: "customer_error" },
	{ field: "pickup", elementId: "pickup-details" },
	{ field: "delivery", elementId: "delivery-details" },
];

/** Returns the DOM id of the first invalid field, in on-screen top-to-bottom order. */
export function getFirstErrorElementId(
	errors: FormValidationErrors,
	itemOrder: number[],
): string | null {
	for (const { field, elementId } of TOP_LEVEL_FIELD_ORDER) {
		if (errors.fields.has(field)) {
			return elementId;
		}
	}

	for (const itemId of itemOrder) {
		if (errors.items[itemId]?.size) {
			return `commodity-handling-unit-${itemId}`;
		}
	}

	return null;
}

/** Scrolls to (and focuses, if possible) the first invalid field so mobile users can see and act on validation errors. */
export function scrollToFirstError(
	errors: FormValidationErrors,
	itemOrder: number[],
): void {
	const elementId = getFirstErrorElementId(errors, itemOrder);
	if (!elementId) {
		return;
	}

	const element = document.querySelector<HTMLElement>(`#${elementId}`);
	if (!element) {
		return;
	}

	element.scrollIntoView({ behavior: "smooth", block: "center" });

	const focusable = element.matches("input, select, textarea, button")
		? element
		: element.querySelector<HTMLElement>("input, select, textarea, button");
	focusable?.focus();
}
